import { cn } from '@risksmart-app/atomic-ui';
import { Controller, useFormContext } from 'react-hook-form';

import { RichTextEditor } from './RichTextEditor';

export const GuidanceField = ({ placeholder }: { placeholder?: string }) => {
  const { control } = useFormContext();

  return (
    <div className={cn('pt-4')}>
      <Controller
        control={control}
        name={'guidance'}
        render={({ field }) => (
          <RichTextEditor
            value={field.value ?? ''}
            onChange={field.onChange}
            placeholder={placeholder ?? 'Add guidance text...'}
          />
        )}
      />
    </div>
  );
};
